export const LOAD_TICKETS = "loadTickets";
